import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';
import { environment } from "../../environments/environment";
import { BBResponseContainer } from '../carrier/response-container';
import { timeout, tap, catchError, map } from 'rxjs/operators';
import { DeliveryPackage } from './deliveryPackage';
import { ShipmentBoxReception } from '../apg-deliver-box-manager/shipmentBoxDetails';
import { DeliveryBoxReception } from '../apg-deliver-box-manager/deliveryBoxDetails';

@Injectable()
export class  ApgDeliveryService {

  readonly timeoutForExcelSave = 30000;

  constructor(private http: HttpClient) {
  }


  getDelivery(queryString : string,deliveryStatus:string,skip,limit): Observable<BBResponseContainer> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL +'animal/delivery/search';
    let requestParam = new HttpParams().set('queryString', queryString).set('deliveryStatus',deliveryStatus).set('skip', skip).set('limit',limit);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));

  }

  saveDelivery(formData: FormData): Observable<BBResponseContainer>{
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "apg/shipment";
    return this.http.post<BBResponseContainer>(url, formData).pipe(timeout(this.timeoutForExcelSave), tap(event => { }, error => {
      error.url = url;
    }));
  }

  updateDelivery(formData: FormData): Observable<BBResponseContainer> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "apg/shipment/update";
    return this.http.post<BBResponseContainer>(url, formData).pipe(timeout(this.timeoutForExcelSave), tap(event => { }, error => {
      error.url = url;
    }));
  }

  deleteDelivery(deliverypackage: DeliveryPackage): Observable<BBResponseContainer> {
   deliverypackage.isDeleted = true;
   let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "apg/shipment/delete";
   return this.http.put<BBResponseContainer>(url, deliverypackage).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
     error.url = url;
   }));
 }

 getBoxDetails(lab:string,id:string): Observable<BBResponseContainer>  {
  let url = environment.BB_APG_SAMPLE_PROCESSING_URL +'apg/shipment/count/' + id + '/' + lab;
  return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
    error.url = url;
  }));
}

receiveBox(lab:string,boxId:string,sender:string){
  let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "apg/shipment/box/receive";
  return this.http.post<BBResponseContainer>(url, {lab,boxId,sender}).pipe(timeout(this.timeoutForExcelSave), tap(event => { }, error => {
    error.url = url;
  }));
}

deleteBox(lab:string,boxId:string,sender:string){
  let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "apg/shipment/box/delete";
  return this.http.put<BBResponseContainer>(url, {lab,boxId,sender}).pipe(timeout(this.timeoutForExcelSave), tap(event => { }, error => {
    error.url = url;
  }));
}

updateShipmentStatus(selectedLabId: string, shipmentId: string, status: string) {
  let url = environment.BB_APG_SAMPLE_PROCESSING_URL + 'apg/shipment/status/' + selectedLabId + "/" + shipmentId; 
  return this.http.put<BBResponseContainer>(url, status).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
  error.url = url;
  }));
  }

downloadExcel(selectedLabId: string, shipmentId: string) {
  return this.http.get(environment.BB_APG_SAMPLE_PROCESSING_URL + 'apg/shipment/excelGenerationForShipment/' + selectedLabId + '/' + shipmentId,
    { observe: 'response', responseType: 'blob' }).pipe(
      map((res) => {
        let data = {
          fileContent: new Blob([res.body], { type: res.headers.get('content-Type') })
        }
        return data;
      }), catchError(error => Observable.throw(null)));
}

receiveBoxForShipment(lab:string,boxId:string,sender:string,shipemtId:string,useGivenShipment:boolean){
  let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "apg/shipment/shipmetId/box/receive";
  return this.http.post<BBResponseContainer>(url, {lab,boxId,sender,shipemtId,useGivenShipment}).pipe(timeout(this.timeoutForExcelSave), tap(event => { }, error => {
    error.url = url;
  }));
}
searchDeliveries(queryString : string,shipmentStatus:string) {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + 'apg/shipment/search?queryString='+queryString+'&shipmentStatus='+shipmentStatus; 
    return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
    error.url = url;
    }));
}
exportShipment(queryString: string,shipmentStatus:string) {
  return this.http.get(environment.BB_APG_SAMPLE_PROCESSING_URL + 'apg/shipment/export?queryString='+queryString+'&shipmentStatus='+shipmentStatus,
    { observe: 'response', responseType: 'blob' }).pipe(
      map((res) => {
        let data = {
          fileContent: new Blob([res.body], { type: res.headers.get('content-Type') })
        }
        return data;
      }), catchError(error => Observable.throw(null)));
}

validateBox(deliveryId: string): Observable<BBResponseContainer> {
  let url = environment.BB_APG_SAMPLE_PROCESSING_URL + 'animal/delivery/validate';
  let requestParam = new HttpParams().set('deliveryId', deliveryId);
  const options = url ? { params: requestParam } : {};
  return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
    error.url = url;
  }));
}

performBoxReception(deliveryBoxReception:DeliveryBoxReception[]) {
  let url = environment.BB_APG_SAMPLE_PROCESSING_URL + 'animal/delivery/receive'; 
  return this.http.put<BBResponseContainer>(url,deliveryBoxReception).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
  error.url = url;
  }));
}
downloadExcelForDelivery(delivery:string , deliveryStatus:string){
  return this.http.get(environment.BB_APG_SAMPLE_PROCESSING_URL +'animal/delivery/excelGenerationForDelivery/' + delivery+'/'+deliveryStatus,
  { observe: 'response', responseType: 'blob' }).pipe(
    map((res) => {
      let data = {
        fileContent: new Blob([res.body],{type: res.headers.get('content-type')})   
      }
      return data;
    }
  ),catchError(error => Observable.throw(null)));
}


}





